"use strict";
/**
 * Moderation `malware` canonical template — single source of truth for the
 * `moderation-malware` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY (setup lambda registers; moderation-history
 * reads by alias), have NO search-document interface, and are NOT read by application
 * search queries — so they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants, no
 * interface). Field types ported VERBATIM from the setup lambda's inline
 * `moderation-malware` block. No analyzers (plain mappings), so `settings.analysis`
 * is OMITTED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationMalwareTemplate = buildModerationMalwareTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-malware` family. */
function buildModerationMalwareTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    identity_id: { type: 'keyword' },
                    pattern_id: { type: 'keyword' },
                    pdf_hash: { type: 'keyword' },
                    reason: { type: 'keyword' },
                    violation_type: { type: 'keyword' },
                    screen_name: { type: 'keyword' },
                    resolved: { type: 'boolean' },
                    resolved_by: { type: 'keyword' },
                    resolved_at: { type: 'date' },
                    created_at: { type: 'date' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-malware' },
    };
}
